import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js" // Import the 'get' function

// Connects to data-controller="infinite-scroll"
export default class extends Controller {
  static values = { url: String } // Define a 'url' value

  connect() {
    this.observer = new IntersectionObserver(this.loadMore.bind(this), {
      rootMargin: "200px",
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.unobserve(this.element)
  }

  loadMore(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Disconnect the observer to prevent multiple requests while loading
        this.observer.disconnect()

        // Use request.js to fetch the next page as a turbo_stream
        get(this.urlValue, {
          responseKind: "turbo-stream"
        })
      }
    })
  }
}